import src from "IMAGE";
export default { src, width: 899, height: 312, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAQAAAAEwYbDAAAAPklEQVR42gEzAMz/AP87/0j/Lv8M/w//EP8P/w4A/z3/Uv8z/zr/RP9M/0v/SQD/GP85/xH/Ev8V/xj/GP8Y1Rkb07KLrQAAAAAASUVORK5CYII="};
